/*
* Copyright (c) 2019
* Reliant Business Valuation, LLC - http://reliantvalue.com
* Author: Kirill Vizniuk - kirill@internalvaluation.com
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
* http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

import {SearchableItem} from './interface/searchable.item';
import {SearchableSelectionType} from './interface/searchable.selection';

export class Franchise implements SearchableItem {
    ID: string;
    NAME: string;
    COMPANY_HISTORY:string;
    ROYALTY_FEES: string;
    MARKETING_ADVERTISING_FEES:string;
    FRANCHISE_TERM_LENGTH:string;
    PRICING:string;
    COMPETITION:String;
    FRANCHISE_SCORE = 5;
    IS_ADDED: boolean;
    
    
    active = false;
    selected = false;
    allowed = false;
    
    static parse(json: any): Franchise {
    if (json) {
    const s = new Franchise();
    
    s.ID = json.ID;
    s.NAME = json.NAME;
    s.IS_ADDED = json.IS_ADDED;
    s.COMPANY_HISTORY=json.COMPANY_HISTORY_AND_INTIAL_FRANCHISE_FEE;
    s.ROYALTY_FEES=json.ROYALTY_FEES;
    s.MARKETING_ADVERTISING_FEES=json.MARKETING_ADVERTISING_FEES;
    s.FRANCHISE_TERM_LENGTH=json.FRANCHISE_TERM_LENGTH;
    s.COMPETITION=json.COMPETITION;
    
    return s;
    } else return null;
    }
    
    static parseArray(json: any[]): Franchise[] {
    const arr = [];
    
    if (json)
    for (const j of json)
    if (j)
    arr.push(Franchise.parse(j));
    
    return arr;
    }
    
    getName(): string {
    return this.NAME;
    }
    
    getFullDetails(): string {
    return this.NAME;
    }
    
    getType(): SearchableSelectionType {
    return SearchableSelectionType.VALUE;
    }
    
    getValue(): any {
    return this;
    }
}